module.exports = __webpack_public_path__ + "img/Aufzaehlungszeichen.a9184579.svg";